import styled, { css } from 'styled-components';
import { ifProp, palette, switchProp, theme } from 'styled-tools';

export type ButtonProperties = {
  size: 'lg' | 'md' | 'sm';
  secondary: boolean;
};

export const Button = styled.button<ButtonProperties>`
  display: inline-flex;
  align-items: center;
  border: 0;
  border-radius: 25px;
  outline: none;
  cursor: pointer;
  font-weight: ${theme('fontWeight.regular')};
  color: ${ifProp(
    'secondary',
    palette('colorButtonSecondary'),
    palette('colorButtonPrimary')
  )};
  background-color: ${ifProp(
    'secondary',
    palette('bgButtonSecondary'),
    palette('bgButtonPrimary')
  )};
  transition: ${theme('transition')};

  ${switchProp('size', {
    sm: css`
      height: ${ifProp('link', 'auto', '32px')};
      padding: 0 ${ifProp('link', '0', theme('spacing.md'))};
      font-size: ${theme('fontSize.xs')};
      ${theme('components.Button.sizes.sm')}
    `,
    md: css`
      height: ${ifProp('link', 'auto', '40px')};
      padding: 0 ${ifProp('link', '0', theme('spacing.lg'))};
      font-size: ${theme('fontSize.sm')};
      ${theme('components.Button.sizes.md')}
    `,
    lg: css`
      height: ${ifProp('link', 'auto', '48px')};
      padding: 0 ${ifProp('link', '0', theme('spacing.lg'))};
      font-size: ${theme('fontSize.sm')};
      ${theme('components.Button.sizes.lg')}
    `,
  })}
  &:hover {
    background-color: ${ifProp(
      'secondary',
      palette('bgButtonSecondaryHover'),
      palette('bgButtonPrimaryHover')
    )};
  }

  &:active {
    background-color: ${ifProp(
      'secondary',
      palette('bgButtonSecondaryActive'),
      palette('bgButtonPrimaryActive')
    )};
  }

  &:disabled {
    background-color: ${ifProp(
      'secondary',
      palette('bgButtonSecondaryDisabled'),
      palette('bgButtonPrimaryDisabled')
    )} !important;
    color: ${ifProp(
      'secondary',
      palette('colorButtonSecondaryDisabled'),
      palette('colorButtonPrimaryDisabled')
    )} !important;
    cursor: not-allowed;
  }

  ${theme('components.Button.default')}
`;

export const Link = styled(Button)`
  color: ${palette('textLink')};
  background-color: transparent;
  display: inline;
  transition: ${theme('transition')};
  cursor: pointer;
  height: auto;
  padding: 0;

  &:hover {
    color: ${palette('textLinkHover')};
    background-color: transparent;
  }

  &:active {
    background-color: transparent;
  }

  &:disabled {
    ${theme('components.Button.link')}
  }
`;
